import { Application } from "@hotwired/stimulus"

const application = Application.start()

// Opcional: Activa/desactiva debug
application.debug = false

// Opcional: Hace visible Stimulus en el `window` para debug manual
window.Stimulus = application

export { application }
